import { Route, Routes, Navigate } from 'react-router-dom';
import { UserInfoPage } from '../../pages/Profile/UserInfoPage';
import { ChangePasswordPage } from '../../pages/Profile/ChangePasswordPage';

export function AppProfile() {

    return (

        <Routes>
            <Route
                path="/"
                element={<UserInfoPage />}
            />
            <Route
                path="/changePassword"
                element={<ChangePasswordPage />}
            />
            <Route path="*" element={<Navigate to="Users" replace={true} />} />
        </Routes>
       
    );

}